// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1MGQr","image":"Header_image__Tfcx8","name":"Header_name__3Zwfu","info":"Header_info__iHbtX","infoRow":"Header_infoRow__34cqw"};